<template lang="pug">
.ant-forest-success(
  v-infinite-scroll="load",
  infinite-scroll-disabled="loading",
  infinite-scroll-distance="10"
)
  .remind(v-if='!agree')
    .left
      img(src="https://m.hellobike.com/resource/AppPlatformH5/ant-forest/AOQUcvEQLIZ_N65vsfwR0.svg")
      span 哈啰有新的业务接入蚂蚁森林啦~
    .right(@click='authorization') 立即授权
  .rule(@click="goRule" :class="{move:!agree}") 说明
  .question-popup(:class="{ show: popup }", @click="popup = false") 仅统计哈啰APP中产生的能量
  .banner
    img.bg(
      alt="banner",
      src="https://m.hellobike.com/resource/AppPlatformH5/ant-forest/a0nE8WoM8dw-miyI740uS.png"
    )
    .content
      .line-1 APP共产生能量(g)
        .question.flex-mid(@click="showPopup")
          .signal ?
      .number
        .bit.flex-mid(v-for="i in showEnergy") {{ i }}
      .account 能量已发放至您绑定的支付宝账号
  .part-1
    .tips
      div
        span · 使用
        span.black 支付宝/花呗
        span 支付的骑行订单可获能量
      div
        span · 使用
        span.black 支付宝/花呗
        span 支付购买的骑行卡骑行可获能量
    .buy.flex-mid(@click="buyCard") 去购卡
  template(v-if="!empty")
    .part-2
      .record-item(v-for="item in records")
        .left.flex-mid
          img(alt="icon", :src="item.icon || img.bike")
        .mid
          .title {{ item.title }}
          .subtitle {{ item.time }}
        .right.flex-mid {{ item.amount }}g
    .hint(v-if="!more") 没有更多了
  template(v-else)
    .empty.flex-mid
      img.empty-icon(
        src="https://m.hellobike.com/resource/AppPlatformH5/bounty/O0US02pnkxlShWTWzqE7t.png",
        alt="empty"
      )
      .empty-title 近6个月您还没有产生能量
      .empty-subtitle 快去骑车产生绿色能量吧
  template
    Dialog(
      :show="dialog",
      title="授权内容更新",
      content="哈啰有新业务接入蚂蚁森林啦，为了方便大家不错过能量，授权内容作出如下更新：出行开始时间、结束时间、出行里程，以及其它用于计算能量所必需之数据。",
      okText="暂不授权",
      cancelText="同意",
      @cancel="ok",
      @ok="close"
    )
</template>

<script>
import Toast from '@/components/toast';
import { InfiniteScroll } from 'mint-ui';
import dayjs from 'dayjs';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import {
  getForestPointsInfo,
  getForestRecord,
  getForestAccountStatus,
  updateAuth,
} from '../../api/ant-forest';
import { getTokenAndKey, getTokenAndLocation } from '../../utils/index';
import Dialog from './components/dialog';

let account = null;

const mapItemTitle = (biz) => {
  if (biz === 'bike') {
    return '单车骑行';
  }
  if (biz === 'ebike') {
    return '助力车骑行';
  }
  if (biz === 'electric') {
    return '电动车骑行';
  }
  return '其他';
};

export default {
  components: {
    Dialog,
  },
  directives: {
    InfiniteScroll,
  },
  data() {
    return {
      agree: true, // 是否同意
      loading: false,
      more: true,
      popup: false,
      dialog: false, // 弹框
      img: {
        bike:
          'https://m.hellobike.com/resource/AppPlatformH5/ant-forest/BxKz4to2HHRSpxxCFXDbw.png',
        ebike:
          'https://m.hellobike.com/resource/AppPlatformH5/ant-forest/_n7-xreIUKSeF3fnlerdh.png',
        electric:
          'https://m.hellobike.com/resource/AppPlatformH5/ant-forest/bZzheYx3D9xl9jWXGIASp.png',
      },
      account: null,
      energy: '0',
      card: {
        bike: 0,
        ebike: 0,
      },
      pageIndex: 1,
      pageSize: 10,
      records: [],
      last: 0,
    };
  },
  computed: {
    empty() {
      return !this.records || this.records.length === 0;
    },
    showEnergy() {
      if (!this.energy) {
        return '000000'.split('');
      }
      return ('000000'.slice(0, 6 - this.energy.length) + this.energy).split(
        '',
      );
    },
  },
  created() {
    if (account) {
      this.account = account;
    }
  },
  async mounted() {
    UBT.pageView({
      pageId: 'platform_ant_forest_detail_page',
      categoryId: 'platform',
      businessInfo: {},
    });
    await this.initUser();
    this.getBasic();
    this.load();
  },
  methods: {
    buyCard() {
      UBT.clickButton({
        pageId: 'platform_ant_forest_detail_page',
        buttonName: 'platform_purchase',
        categoryId: 'platform',
        businessInfo: {},
      });
      window.location.href = 'hellobike://hellobike.com/wallet?toTop=1';
    },
    goRule() {
      UBT.clickButton({
        pageId: 'platform_ant_forest_detail_page',
        buttonName: 'platform_rules',
        categoryId: 'platform',
        businessInfo: {},
      });
      this.$router.push({
        path: '/ant-forest/success',
        query: {
          account: this.account,
        },
      });
    },
    async load() {
      if (!this.more) {
        return;
      }
      const now = new Date().getTime();
      if (now - this.last < 200) {
        return;
      }
      this.last = now;
      const { token } = await this.initUser();
      getForestRecord({
        token,
        pointType: 2,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      }).then(({ data }) => {
        if (data && data.data) {
          if (data.data.length < this.pageSize) {
            this.more = false;
          }
          this.records = this.records.concat(
            data.data.map(({ biz, points, issueTime }) => ({
              title: mapItemTitle(biz),
              time: dayjs(issueTime).format('YYYY-MM-DD HH:mm'),
              icon: this.img[biz] || '',
              amount: points,
            })),
          );
          // console.log(this.records);
        }
      });
      this.pageIndex += 1;
    },
    async getBasic() {
      const { token, cityCode, adCode } = await getTokenAndLocation();
      getForestAccountStatus({
        token, cityCode, adCode, pointType: 2,
      }).then((v) => {
        if (v && v.data) {
          const { antGray, antStatus } = v.data;
          if (antStatus === 1 && antGray) {
            this.dialog = true;
          }
        }
      });
      getForestPointsInfo({ token, pointType: 2, showRelatedAccount: true })
        .then(({ data }) => {
          if (data) {
            this.energy = String(data.points || 0);
            account = data.relatedAccount;
            if (!this.account) {
              this.account = data.relatedAccount;
            }
          }
        })
        .catch(() => {
          //
        });
    },
    showPopup() {
      this.popup = true;
      UBT.clickButton({
        pageId: 'platform_ant_forest_detail_page',
        buttonName: 'platform_notes_for_number',
        categoryId: 'platform',
        businessInfo: {},
      });
    },
    initUser() {
      return getTokenAndKey().catch(() => ({}));
    },
    close() {
      // 不同意
      this.dialog = false;
      this.agree = false;
    },
    async ok() {
      // 弹框同意
      this.dialog = false;
      this.agree = true;
      const { token } = await getTokenAndKey();
      updateAuth({ pointType: 2, token }).then(() => {
        Toast.show('授权成功');
      }).catch(() => {
        Toast.show('授权失败，请稍后重试');
      });
    },
    authorization() {
      this.dialog = true;
    },
  },
};
</script>

<style lang="less" scoped>
.ant-forest-success {
  display: flex;
  align-items: center;
  flex-direction: column;
  min-height: 100%;
  padding-bottom: 0.57rem;
  background-color: rgba(240, 243, 245, 1);

  img {
    pointer-events: none;
  }

  .remind {
    width: 100%;
    height: 0.4rem;
    background-color: #fef4e7;
    display: flex;
    line-height: 0.4rem;
    font-size: 0.13rem;
    font-weight: 400;
    color: #ee8c02;
    padding: 0 0.12rem;
    justify-content: space-between;

    img {
      width: 0.14rem;
      height: 0.14rem;
      margin-right: 6px;
    }

    .left {
      display: flex;
      align-items: center;
    }

    .right {
      position: relative;
      margin-right: 0.1rem;

      &::after {
        content: "";
        display: block;
        position: absolute;
        top: 50%;
        right: -0.1rem;
        width: 0.08rem;
        height: 0.08rem;
        border-bottom: 0.02rem solid #ee8c02;
        border-right: 0.02rem solid #ee8c02;
        transform: translateY(-50%) rotate(-45deg) scale(0.7);
      }
    }
  }

  .rule {
    position: absolute;
    right: 0;
    top: 0.15rem;
    width: 0.45rem;
    height: 0.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.16);
    border-radius: 0.5rem 0 0 0.5rem;
    font-size: 0.12rem;
    color: rgba(255, 255, 255, 1);
    z-index: 11;

    &.move {
      top: 0.5rem;
    }
  }

  .question-popup {
    position: absolute;
    top: 0.5rem;
    left: 0.5rem;
    z-index: 3000;
    font-size: 0.13rem;
    color: #fff;
    background-image: url(https://m.hellobike.com/resource/AppPlatformH5/ant-forest/hyUyHg9wlmD6Lh25DQ4Zz.png);
    background-size: 100% 100%;
    width: 2.53rem;
    height: 0.55rem;
    display: flex;
    align-items: center;
    padding-left: 0.19rem;
    opacity: 0;
    transition: all 0.3s ease;
    padding-top: 3px;

    &.show {
      opacity: 1;
      top: 0.4rem;
    }

    &::before,
    &::after {
      content: " ";
      display: block;
      position: absolute;
      top: 54%;
      right: 0.18rem;
      width: 0.16rem;
      height: 2px;
      transform: translateY(-50%) rotate(45deg);
      background-color: rgba(255, 255, 255, 0.6);
      border-radius: 4px;
    }

    &::after {
      transform: translateY(-50%) rotate(-45deg);
    }
  }

  .banner {
    display: flex;
    margin-bottom: -0.22rem;
    position: relative;

    .bg {
      height: 2.15rem;
    }

    .content {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 0.23rem;
      color: white;
      display: flex;
      flex-direction: column;
      align-items: center;

      .line-1 {
        font-size: 0.14rem;
        font-weight: 600;
        line-height: 0.2rem;
        position: relative;

        .question {
          position: absolute;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          width: 0.14rem;
          height: 0.14rem;
          border-radius: 50%;
          right: -0.2rem;
          font-weight: 300;
          top: 50%;
          transform: translateY(-50%);
          background: #0092ce;
          font-size: 0.12rem;
          color: #fff;

          .signal {
            transform: scale(0.8);
            position: relative;
            top: 1.4px;
          }
        }
      }

      .number {
        font-size: 0.28rem;
        font-family: "DIN Alternate Bold", sans-serif;
        font-weight: bold;
        color: #1993ff;
        display: flex;
        margin-top: 0.12rem;
        margin-bottom: 0.09rem;

        .bit {
          width: 0.25rem;
          height: 0.44rem;
          background: #fff;

          &:not(:last-of-type) {
            margin-right: 0.04rem;
          }
        }
      }

      .account {
        font-size: 0.11rem;
        color: #fff;
        line-height: 0.16rem;
        white-space: nowrap;
      }
    }
  }

  .part-1 {
    width: 3.51rem;
    background: #fff;
    border-radius: 0.08rem;
    box-shadow: 0 0.01rem 0.04rem 0 rgba(0, 0, 0, 0.02);
    overflow: hidden;
    margin-bottom: 0.08rem;
    padding: 0.12rem 0.08rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    z-index: 1;

    .title {
      font-size: 0.14rem;
      font-weight: 500;
      color: #242729;
      line-height: 0.2rem;
      margin-bottom: 0.04rem;

      .blue {
        color: rgba(0, 136, 255, 1);
      }
    }

    .tips {
      font-size: 0.12rem;
      color: #879099;
      line-height: 0.17rem;

      .black {
        color: rgba(36, 39, 41, 1);
      }
    }

    .buy {
      margin-top: 0.07rem;
      width: 0.6rem;
      height: 0.24rem;
      background: #08f;
      border-radius: 0.12rem;
      font-size: 0.12rem;
      font-weight: 500;
      color: #fff;
      line-height: 1;
    }
  }

  .part-2 {
    width: 3.51rem;
    background: #fff;
    border-radius: 0.08rem;
    padding: 0 0.12rem;

    .record-item {
      display: flex;
      height: 0.68rem;
      position: relative;

      &:not(:last-of-type) {
        &::after {
          content: "";
          width: 100%;
          height: 0.01rem;
          background: rgba(255, 255, 255, 0);
          box-shadow: 0 0.01rem 0 0 #f0f3f5;
          position: absolute;
          left: 0;
          bottom: 0;
        }
      }

      .left {
        margin-right: 0.12rem;

        img {
          width: 0.28rem;
          height: 0.28rem;
        }
      }

      .mid {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;

        .title {
          font-size: 0.14rem;
          font-weight: 600;
          color: #242729;
          line-height: 0.2rem;
          margin-bottom: 0.04rem;
        }

        .subtitle {
          font-size: 0.14rem;
          color: #879099;
          line-height: 0.2rem;
        }
      }

      .right {
        font-size: 0.14rem;
        color: #242729;
        line-height: 0.2rem;
      }
    }
  }

  .empty {
    flex-direction: column;

    .empty-icon {
      width: 1.91rem;
      margin-top: 0.6rem;
      margin-bottom: 0.16rem;
    }

    .empty-title {
      font-size: 0.16rem;
      color: #242729;
      line-height: 0.22rem;
      margin-bottom: 0.08rem;
    }

    .empty-subtitle {
      font-size: 0.14rem;
      color: #879099;
      line-height: 0.2rem;
    }
  }

  .hint {
    font-size: 0.12rem;
    color: #bcc4cc;
    line-height: 0.17rem;
    margin-top: 0.12rem;
  }
}
</style>
